import { i18n, observer, pr, React, theme, ui } from "aaa";
import { CSSProperties, ReactNode } from "react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { GeorgeCheckbox } from "./GeorgeCheckbox";
import { GeorgeRadioButton } from "./GeorgeRadioButton";
import { NativeFlatButton } from "./NativeFlatButton";
import { NativePaper } from "./NativePaper";
import { NativeRaisedButton } from "./NativeRaisedButton";

export { ChooseAccount } from "./ChooseAccount";
export { ChooseAddress } from "./ChooseAddress";
export { ChooseDesign } from "./ChooseDesign";
export { ChooseEmail } from "./ChooseEmail";
export { ChooseLimit } from "./ChooseLimit";
export { ChoosePhone } from "./ChoosePhone";
export { ChoosePin, ChoosePinEmbedded } from "./ChoosePin";
export { ChooseReleaseKey } from "./ChooseReleaseKey";
export { ChooseTopUp, ChooseTopUpEmbedded } from "./ChooseTopUp";
export { GeorgeCheckbox as Checkbox, GeorgeCheckboxFormsy as CheckboxFormsy } from "./GeorgeCheckbox";
export { GeorgeDropDown as DropDown, GeorgeDropDownFormsy as DropDownFormsy } from "./GeorgeDropDown";
export { GeorgeRadioButton as RadioButton } from "./GeorgeRadioButton";
export { GeorgeCenteredTextField as CenteredTextField, GeorgeTextField as TextField, GeorgeTextFieldFormsy as TextFieldFormsy } from "./GeorgeTextField";

export class CardSectionTitle extends React.Component<{ title: string, style?: CSSProperties, focus?: Boolean }, {}> {
    ref: any;

    componentDidMount() {
        if (this.ref) {
            this.ref.focus();
        }
    }

    render() {
        return (
            <h2
                ref={c => this.ref = c}
                className="theme-card-title theme-title-color"
                style={this.props.style}
            >
                {this.props.title}
            </h2>
        );
    }

}

export const CardSectionContent = pr.styledDiv({
    paddingLeft: theme.MARGIN,
    paddingRight: theme.MARGIN,
    paddingBottom: theme.MARGIN
});

export const SectionTitle = (props: { children: any, style?: CSSProperties }) => (
    <h2 className="theme-title-color" style={{ fontSize: 16, fontWeight: 600, marginBottom: 8, ...props.style }}>{props.children}</h2>
);

export const SectionSubtitleTop = (props: { children: any, style?: React.CSSProperties }) => (
    <p
        className="theme-paragraph-color theme-card-paragraph-font"
        style={{
            marginBottom: theme.MARGIN,
            ...props.style
        }}
    >
        {props.children}
    </p>
);

export const SectionSubtitle = (props: { children: any, style?: React.CSSProperties }) => (
    <p
        className="theme-paragraph-color theme-card-paragraph-font"
        style={props.style}
    >
        {props.children}
    </p>
);

export const LoadingIndicator = observer((props: {
    isLoading?: boolean,
    width?: number | string,
    height?: number | string,
    white?: boolean,
    ignoreDarkMode?: boolean,
    style?: React.CSSProperties
}) => {
    const darkModeTheme = props.ignoreDarkMode ? "" : "theme-loading-indicator-color";
    let backgroundColor;
    if (props.white) {
        backgroundColor = "white";
    }

    if (props.ignoreDarkMode) {
        backgroundColor = "#415b76";
    }

    const getHeight = () => {
        if (typeof props.height === "number") {
            return Math.min(props.height ?? 50, ui.windowHeight - (externalInterfaceStore.isGeorgeWeb ? theme.WEB_HEADER_HEIGHT : 0));
        }

        return props.height;
    };

    return (
        <div
            style={{
                display: props.isLoading ? "flex" : "none",
                width: props.width,
                height: props.height ? getHeight() : 50,
                alignItems: "center",
                justifyContent: "center",
                ...props.style
            }}
            role="progressbar"
            aria-label={ui.__("a11y.loading")}
        >
            <div className="spinner">
                <div className={`bounce1 ${darkModeTheme}`} style={{ backgroundColor }} />
                <div className={`bounce2 ${darkModeTheme}`} style={{ backgroundColor }} />
                <div className={`bounce3 ${darkModeTheme}`} style={{ backgroundColor }} />
            </div>
        </div>
    );
});

export const StoreLoadingIndicator = LoadingIndicator;

const ActionButtonBase = (props: {
    messageId?: i18n.IDS,
    disableButton?: boolean,
    onClick?: (event: any) => void,
    primary?: boolean,
    isLoading?: boolean,
    submit?: boolean,
    color?: string,
    inline?: boolean,
    buttonStyle?: React.CSSProperties,
}) => {
    const height = props.inline ? theme.ACTION_BUTTON_HEIGHT_INLINE : theme.ACTION_BUTTON_HEIGHT;

    return (
        <NativeRaisedButton
            className="theme-action-button-background-color"
            disabled={props.disableButton || props.isLoading}
            secondary={!props.color && !props.primary}
            primary={!props.color && props.primary}
            fullWidth={!props.inline}
            style={{
                height,
                borderRadius: props.buttonStyle?.borderRadius ?? theme.BORDER_RADIUS,
            }}
            buttonStyle={{
                borderRadius: theme.BORDER_RADIUS,
                fontSize: 16,
                fontWeight: 600,
                paddingLeft: theme.MARGIN,
                paddingRight: theme.MARGIN,
                minWidth: props.inline ? 150 : undefined,
                ...props.buttonStyle,
            }}
            labelStyle={{
                height: theme.ACTION_BUTTON_HEIGHT,
            }}
            onClick={(event: any) => {
                if (!props.disableButton && props.onClick) {
                    props.onClick(event);
                }
            }}
            type={props.submit ? "submit" : "button"}
            backgroundColor={props.color}
        >
            {props.messageId && !props.isLoading &&
                <pr.VCenterDiv style={{ height, justifyContent: "center" }}>
                    <span style={{ color: props.disableButton ? theme.themeColors.d_grey_100 : "white", lineHeight: "24px", display: "inline-block" }}>
                        <i18n.FormattedMessage id={props.messageId} />
                    </span>
                </pr.VCenterDiv>
            }
            <LoadingIndicator isLoading={props.isLoading} height="100%" />
        </NativeRaisedButton>
    );
};

// These Props should fix the buttons alignment when rendered inside a Card for either transactionapp or georgeclient with the Design introduced with HYB-100
export const getActionButtonWebVersionProps = () => ({
    inline: !externalInterfaceStore.isGeorgeApp,
    style: !externalInterfaceStore.isGeorgeApp ? { padding: theme.MARGIN, paddingBottom: theme.MARGIN_LARGE } : undefined,
    innerStyle: externalInterfaceStore.isGeorgeApp ? { margin: 0 } : undefined
});

export const ActionButton = (props: {
    messageId?: i18n.IDS,
    disableButton?: boolean,
    onClick?: (event: any) => void,
    primary?: boolean,
    isLoading?: boolean,
    submit?: boolean,
    color?: string,
    style?: React.CSSProperties,
    innerStyle?: React.CSSProperties,
    inline?: boolean,
    buttonStyle?: React.CSSProperties,
}) => {
    const style: CSSProperties = props.inline ? {
        textAlign: "center",
        ...props.style
    } : {
        position: "fixed",
        maxWidth: theme.MAX_APP_WIDTH,
        width: "100%",
        zIndex: 30,
        bottom: 15,
        marginLeft: "auto",
        marginRight: "auto",
        ...props.style
    };

    return props.inline
        ? (
            <div style={style}>
                <ActionButtonBase {...props} />
            </div>
        ) : (
            <div style={style}>
                <div style={{ ...pr.STYLE_CENTERED_CARD, ...props.innerStyle }}>
                    <ActionButtonBase {...props} />
                </div>
            </div >
        );
};

export const SuccessButton = (props: {
    label: string,
    onClick: () => void,
    disabled?: boolean,
    style?: React.CSSProperties
}) => {
    return (
        <div
            style={{
                position: "fixed",
                paddingTop: 18,
                paddingBottom: 18,
                maxWidth: theme.MAX_APP_WIDTH,
                width: "100%",
                bottom: 0,
                ...props.style
            }}
        >
            <div style={{ marginLeft: 10, marginRight: 10 }}>
                <NativeFlatButton
                    onClick={props.onClick}
                    fullWidth
                    style={{
                        height: theme.ACTION_BUTTON_HEIGHT,
                        color: theme.themeColors.blue_300,
                        fontSize: 16,
                        fontWeight: 600,
                        background: "white",
                        borderRadius: theme.BORDER_RADIUS,
                    }}
                    highlightColor="rgba(255,255,255,0.2)"
                    disabled={props.disabled}
                >
                    {props.label}
                </NativeFlatButton>
            </div>
        </div>
    );
};

export const MessageScreenBackground = observer((props: { children: any, style?: React.CSSProperties }) => {
    const minHeight = externalInterfaceStore.isGeorgeWeb ? `calc(100vh - ${theme.WEB_HEADER_HEIGHT}px)` : "100vh";
    return (
        <div className="theme-message-screen-background theme-message-screen-background-color" style={{ minHeight, ...props.style }}>
            {props.children}
        </div>
    );
});

export const Background = observer((props: { children: any, style?: React.CSSProperties }) => {
    const minHeight = externalInterfaceStore.isGeorgeWeb ? `calc(100vh - ${theme.WEB_HEADER_HEIGHT}px)` : "100vh";
    return (
        <div className="theme-background-color" style={{ minHeight, ...props.style }}>
            {props.children}
        </div>
    );
});

export const LandingBackground = observer((props: { children: any, style?: React.CSSProperties, useWebVersion?: boolean }) => {
    let minHeight = !externalInterfaceStore.isGeorgeApp ? `calc(100vh - ${theme.WEB_HEADER_HEIGHT}px` : "100vh";

    if (props.useWebVersion && !externalInterfaceStore.isGeorgeApp) {
        minHeight = `calc(100vh - ${theme.WEB_HEADER_HEIGHT + theme.HEADER_CONTENT_SPACING}px)`;
    }

    return (
        <div
            className="theme-landing-background-color"
            style={{
                minHeight,
                marginTop: props.useWebVersion && !externalInterfaceStore.isGeorgeApp ? theme.HEADER_CONTENT_SPACING : undefined,
                ...props.style
            }}
        >
            {props.children}
        </div>
    );
});

export const BackgroundWithNavBar = observer((props: { children: any; style?: React.CSSProperties }) => {
    const minHeight = `calc(100vh - ${externalInterfaceStore.isGeorgeWeb ? theme.NAVBAR_HEIGHT + theme.WEB_HEADER_HEIGHT : theme.NAVBAR_HEIGHT}px`;
    return (
        <Background style={{ minHeight, ...props.style }}>
            {props.children}
        </Background>
    );
});

export const PageWithActionButton = pr.styledDiv({
    paddingBottom: theme.ACTION_BUTTON_HEIGHT + theme.MARGIN
});

export const Card = ({
    onClick,
    children,
    elevated = true,
    disableTopSpacing,
    style,
}: {
    onClick?: () => void,
    children: any,
    elevated?: boolean,
    disableTopSpacing?: boolean,
    style?: CSSProperties
}) => (
    // marginTop: 10 doesn't work, so use div instead
    <div
        onClick={onClick}
        style={onClick ? { cursor: "pointer" } : undefined}
        role={onClick ? "button" : undefined}
    >
        {!disableTopSpacing && <div style={{ height: theme.MARGIN_SMALL }} />}
        <NativePaper
            elevated={elevated}
            style={{
                ...pr.STYLE_CENTERED_CARD,
                borderRadius: theme.BORDER_RADIUS,
                boxSizing: "border-box",
                ...style
            }}
        >
            {children}
        </NativePaper>
    </div>
);

export const InputFrame = (props: {
    style: CSSProperties,
    white?: boolean,
    isLoading?: boolean,
    onClick?: () => void,
    children: any,
    role?: string,
    "aria-label"?: string,
    id?: string,
    className?: string,
}) => (
    <div
        id={props.id}
        className={props.className}
        style={{
            position: "relative",
            height: 50,
            border: `1px solid ${props.white === true ? "white" : theme.customColors.georgeInputFrame}`,
            borderRadius: theme.BORDER_RADIUS,
            boxShadow: props.white === true ? undefined : `inset 0 0 3px ${theme.customColors.georgeInputFrame}`,
            // old loading
            // background: props.isLoading ? `url(${props.white === true ? loadingIndicatorWhite : loadingIndicator}) center no-repeat` : undefined,
            ...props.style
        }}
        onClick={props.onClick}
        role={props.role}
        aria-label={props["aria-label"]}
    >
        {/* new loading */}
        <LoadingIndicator isLoading={props.isLoading} white={props.white} />
        {props.children}
    </div>
);

// Attention: Approvals are mandatory checkboxes. You can override this using optional=true
export const Approval = (props: {
    title?: string,
    message: ReactNode,
    defaultChecked?: boolean,
    onCheck: (event: any, checked: boolean) => void,
    radioButton?: { yes: string, no: string }
    optional?: boolean
}) => {
    return (
        <Card>
            <CardSectionTitle title={props.title ? props.title : ui.__("common.approval")} />
            <CardSectionContent>
                {!props.radioButton &&
                    <GeorgeCheckbox
                        label={props.message}
                        onCheck={props.onCheck}
                        defaultChecked={props.defaultChecked}
                        required={!props.optional}
                    />
                }

                {props.radioButton &&
                    <div>
                        <pr.P_14_CONTENT>{props.message}</pr.P_14_CONTENT>
                        <br />
                        <GeorgeRadioButton
                            defaultChecked={props.defaultChecked === true}
                            labelYes={props.radioButton.yes}
                            labelNo={props.radioButton.no}
                            onCheck={props.onCheck}
                        />
                    </div>
                }
            </CardSectionContent>
        </Card >
    );
};

export const ApprovalEmbedded = (props: {
    title?: string,
    message: ReactNode,
    defaultChecked?: boolean,
    onCheck: (event: any, checked: boolean) => void,
    radioButton?: { yes: string, no: string },
    optional?: boolean,
    hideTitle?: boolean
}) => {
    return (
        <>
            {!props.hideTitle &&
                <SectionTitle style={{ marginTop: 0, marginBottom: theme.MARGIN_SMALL }}>
                    {props.title ? props.title : ui.__("common.approval")}
                </SectionTitle>
            }
            {!props.radioButton &&
                <GeorgeCheckbox
                    label={props.message}
                    onCheck={props.onCheck}
                    defaultChecked={props.defaultChecked}
                    required={!props.optional}
                />
            }
            {props.radioButton &&
                <div>
                    <pr.P_14_CONTENT>{props.message}</pr.P_14_CONTENT>
                    <br />
                    <GeorgeRadioButton
                        defaultChecked={props.defaultChecked === true}
                        labelYes={props.radioButton.yes}
                        labelNo={props.radioButton.no}
                        onCheck={props.onCheck}
                    />
                </div>
            }
        </>
    );
};

export const LabeledValue = (props: { label: string, value: string, hideSeparator?: boolean }) => (
    <>
        <div
            style={{
                padding: 12,
                paddingLeft: 0,
                paddingRight: 0,
                display: "flex",
                width: "100%"
            }}
        >
            <pr.P_14_CONTENT style={{ flex: 1 }}>{props.label}</pr.P_14_CONTENT>
            <pr.P_14_TITLE>{props.value}</pr.P_14_TITLE>

        </div>
        {!props.hideSeparator && <pr.LightSeparatorLine />}
    </>
);

export const Fees = (props: { label: string, value: string, style?: CSSProperties }) => (
    <pr.HFlex style={{ marginTop: theme.MARGIN, width: "100%", ...props.style }}>
        <pr.P_14_CONTENT style={{ flex: 1 }}>{props.label}</pr.P_14_CONTENT>
        <pr.P_14_TITLE>{props.value}</pr.P_14_TITLE>
    </pr.HFlex>
);

export const CheckListEntry = (props: {
    title: string,
    checked?: boolean,
    onCheck?: () => void
}) => (
    <pr.HFlexCentered
        style={{ height: 64, paddingLeft: theme.MARGIN, paddingRight: theme.MARGIN }}
        onClick={props.onCheck}
        role="button"
    >
        <div style={{ flex: 1 }}>
            <pr.P_16_TITLE>{props.title}</pr.P_16_TITLE>
        </div>
        {props.checked &&
            <div role="menuitem" aria-label={ui.__("a11y.selected")}>
                <pr.IconCheck style={{ color: theme.customColors.georgeLightBlue }} />
            </div>
        }
    </pr.HFlexCentered>
);

export const ArrowLine = (props: { width: number, style?: CSSProperties }) => (
    <div className="theme-arrow-color" style={{ height: Math.sqrt(2) * props.width / 2, borderBottomWidth: 1, borderBottomStyle: "solid", ...props.style }}>
        <div
            className="theme-arrow-color theme-paper-color"
            style={{
                borderStyle: "solid",
                borderWidth: "1px 1px 0 0",
                transform: "rotate(-45deg)",
                width: props.width,
                height: props.width,
                position: "relative",
                left: "calc(50% - 10px)",
                top: 4,
            }}
        />
    </div>
);

export const SecondaryActionButton = (props: {
    onClick?: () => void;
    messageId: i18n.IDS;
    style?: React.CSSProperties;
    className?: string;
    inline?: boolean;
}) => {

    const height = props.inline ? theme.ACTION_BUTTON_HEIGHT_INLINE : theme.ACTION_BUTTON_HEIGHT;
    const styleBase: React.CSSProperties = {
        paddingBottom: 20,
        paddingTop: 20,
        textAlign: "center",
        fontSize: 14,
        maxWidth: theme.MAX_APP_WIDTH,
        cursor: "pointer",
        height,
    };

    const style: React.CSSProperties = props.inline ? {
        minWidth: 150,
        display: "inline-block",
        paddingLeft: theme.MARGIN,
        paddingRight: theme.MARGIN,
        ...styleBase,
        ...props.style
    } : {
        position: "fixed",
        bottom: 10,
        width: "100%",
        marginLeft: "auto",
        marginRight: "auto",
        ...styleBase,
        ...props.style
    };

    return (
        <div
            className={props.className ?? "theme-secondary-action-button-background-color theme-secondary-action-label-color"}
            style={style}
            role="button"
            onClick={props.onClick}
        >
            {ui.__(props.messageId)}
        </div>
    );
};

// Trick from https://stackoverflow.com/a/1709271 to position <li> bullet image
const bullet = require("../../assets/icon-bulletlist.png");
export const Li = (props: { children: any }) => (
    <li
        style={{
            background: `url(${bullet}) no-repeat left 2px`,
            padding: "0px 0px 0px 25px",
            /* reset styles (optional): */
            listStyle: "none",
            margin: 0,
        }}
    >
        {props.children}
    </li>
);

export const ResponsiveFormElement = ({
    label,
    children,
    style,
    labelStyle,
    elementStyle,
    align = "left"
}: {
    label: React.ReactNode,
    children: React.ReactNode,
    style?: React.CSSProperties,
    labelStyle?: React.CSSProperties,
    elementStyle?: React.CSSProperties,
    align?: "left" | "right"
}) => (
    <div className="two-column-container" style={style}>
        <div className="two-column-label theme-title-color" aria-hidden={ui.isPopupVisible} style={labelStyle}>
            {label}
        </div>
        <div className={`two-column-form-element-${align}`} style={elementStyle}>
            {children}
        </div>
    </div>
);

export const ResponsiveSummaryElement = ({
    label,
    children,
    style,
    labelStyle,
    elementStyle,
    align,
}: {
    label: React.ReactNode,
    children: React.ReactNode,
    style?: React.CSSProperties,
    labelStyle?: React.CSSProperties,
    elementStyle?: React.CSSProperties,
    align?: "left" | "right"
}) => (
    <ResponsiveFormElement
        label={label}
        style={{ alignItems: "flex-start", marginTop: theme.MARGIN, ...style }}
        labelStyle={{ marginBottom: 0, ...labelStyle }}
        elementStyle={elementStyle}
        align={align}
    >
        {children}
    </ResponsiveFormElement>
);



// WEBPACK FOOTER //
// ./src/components/common/georgeComponents.tsx